<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
import screenfull from "screenfull"; //引入screenfull
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },

  created() {
    // 加载教育局定制化配置参数
    // console.log(this.$store.state.eduWebConfig.eduWebConfigInfo.name);
    this.$store.commit("eduWebConfig/getEduWebConfigInfo"); // 根据域名获取当前网页配置参数
  },
  mounted() {
    window.addEventListener("keydown", this.KeyDown, true); //监听按键事件
  },
  methods: {
    toFullscreen() {
      //不支持screenfull全屏，则打印错误
      if (!screenfull.isEnabled) {
        console.error("unEnabled");
        return;
      }
      screenfull.toggle();
    },
    KeyDown(event) {
      if (event.keyCode === 122) {
        event.returnValue = false;
        this.toFullscreen();
      }
    },
    reload() {
      (this.isRouterAlive = false),
        this.$nextTick(function () {
          this.isRouterAlive = true;
        });
    },
  },
};
</script>
<style lang="less">
/* 全局样式 */
@import "../static/css/global.less";
</style>

<style>
@media print {
  /* 打印样式 */
  #printDom .detail_tab tr td {
    border: 1px solid #000;
    color: #000;
  }

  #printDom .detail_tab .content {
    min-height: 250px;
  }

  #printDom .detail_tab tr td .content div {
    font-size: 16px;
  }

  #printDom .detail_tab td {
    line-height: 40px;
    font-size: 16px;
  }

  #printDom .scale_title {
    font-size: 18px;
  }

  #printDom .report_title {
    font-size: 20px;
    line-height: 40px;
  }

  #qrcode img {
    width: 400px;
    height: 400px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
<style media="printContent">
/* 打印边距 */
@page {
  margin: 20mm;
}

/* 量表统计分析 */
@media print {
  #printTotal .echarts {
    margin-left: -70px;
    width: 100%;
  }

  #printTotal .print_warp {
    display: block !important;
    margin: 5px 15px;
  }

  #printTotal .scale_title {
    font-size: 22px;
    line-height: 45px;
    text-align: center;
  }

  #printTotal .content_title {
    font-weight: 600;
    border-bottom: 1px solid #000;
    line-height: 45px;
    padding-left: 15px;
  }

  #printTotal .print_line {
    border-top: 1px solid #000;
  }

  #printTotal .echarts_item {
    height: 300px;
    min-height: 300px;
    /* margin: 40px 0!important; */
  }

  #printTotal .scale_pie {
    border: 1px solid #000;
  }

  #printTotal .comment p {
    font-size: 18px;
  }

  #printTotal .scale_Statistics .text {
    font-size: 16px;
    font-weight: 700;
  }

  #printTotal .focus_personnel,
  #printTotal .invalid_personnel {
    font-size: 16px;
  }

  #printTotal .scale_Statistics .text {
    font-size: 18px;
  }

  #printTotal .scale_Statistics {
    margin: 15px;
  }
}
</style>
<style media="printContent">
/* 告知家长书打印样式 */

@page {
  margin: 20mm;
}

/* 量表统计分析 */
@media print {
  #printDom .signatureReport {
    font-size: 26px;
    color: #000 !important;
    line-height: 70px;
  }
  #printDom .signatureReport .title {
    font-size: 32px;
  }
  #printDom .signatureReport .lineIcon {
    height: 40px;
    border-bottom: 2px dashed #000;
  }
  #printDom .signatureReport .parentLine {
    width: 200px;
  }
}
</style>
<!-- 测评报告 -->
<style media="printDom">
@page {
  margin: 20mm;
}

html {
  background-color: #ffffff;
  height: auto;
  margin: 0px;
}
@media print {
  #printDom.report-warp {
    font-size: 24px;
    color: rgb(81, 90, 110);
  }
  #printDom.report-warp .scale-name {
    font-size: 46px;
    margin-bottom: 50px;
  }
  #printDom.report-warp .student-info div{
    margin-bottom: 10px;
  }
  #printDom.report-warp .create-time,
  #printDom.report-warp .user-name {
    text-align: center;
    font-size: 24px;
  }
  #printDom.report-warp .title {
    font-size: 30px;
  }
   #printDom.report-warp .main .scale{
     font-size: 26px;
   }
  #printDom.report-warp .main .content {
    line-height: 40px;
  }
 #printDom.report-warp .tab-score tr td,#printDom.report-warp .tab-score tr th{
   padding: 10px 5px;
 }
}
</style>


// WEBPACK FOOTER //
// src/App.vue